// src/pages/Products.js
import React from 'react';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import ProductsShowcase from '../components/ProductsShowcase';
import Footer from '../components/Footer';

const Products = () => {
  return (
    <div>
      <SEO
        title="AI Products | Snippy & Sesslink | EDSY Tech"
        description="Explore EdsyTech's AI product suite: Snippy, an AI-powered local shopping platform, and Sesslink, an all-in-one CRM, campaigns, and automation platform with 28 AI tools."
        canonicalPath="/products"
        keywords="AI products, Snippy, Sesslink, AI CRM, AI shopping platform, WhatsApp automation, AI copilot, EdsyTech AI, AI business platform"
      />
      <Navbar />
      <ProductsShowcase />
      <Footer />
    </div>
  );
};

export default Products;
